import { apiCrm } from 'http/index';

class CustomDashboardService {
  getCustomDashboardRepository(queryParams) {
    const { recordType } = queryParams;
    return apiCrm.get(`/custom/bff/dashboard/${recordType}`, {
      params: {
        ...queryParams
      }
    });
  }
  saveConfig(configData) {
    return apiCrm.post('/custom-dashboard', configData);
  }

  updateConfig(configData) {
    return apiCrm.put(`/custom-dashboard/${configData.id}`, configData);
  }

  deleteConfig(id) {
    return apiCrm.delete(`/custom-dashboard/${id}`);
  }

  getCustomDashboardConfig() {
    const createdBy = localStorage.getItem('login');

    return apiCrm.get(`/custom-dashboard/${createdBy}`);
  }
}

export default new CustomDashboardService();
